<template>
  <div class="title">
    <img src="../../images/left_title.png">
     <div class="title_font">{{title}}</div>
    <img src="../../images/left_title.png">
  </div>

</template>
<style src="./title.css" scoped></style>
<script>
    export default {
        name: "title",
        data:()=>({
            title_data:''
        }),
        props:{
          title:{
             type:String,
              default: ''
          }
        },
        created() {
            // this.title_data=this.title
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/title/title.vue